import ForgotPassword from "../pages/forgot-pass/ForgotPassword"
import PasswordReset from "../pages/forgot-pass/PasswordReset"
import Guide from "../pages/guide/Guide"
import Product from "../pages/product/Product"
import Question from "../pages/question/Question"
import Signin from "../pages/signin/Signin"
import Signup from "../pages/signup/Signup"

const AuthenticationRoutes =
{
  path: '/',
  children: [
    {
      path: '/signin',
      element: <Signin />
    },
    {
      path: 'signup',
      element: <Signup />
    },
    {
      path: 'forgot-pass',
      element: <ForgotPassword />
    },
    {
      path: 'product',
      element: <Product />
    },
    {
      path: 'question',
      element: <Question />
    },
    {
      path: 'guide',
      element: <Guide />
    },
    {
      path: 'passwordreset',
      element: <PasswordReset />
    },
  ]
}

export default AuthenticationRoutes